import { EFieldType, Field } from '#models/questionnaire';
import { useFieldStyles, useLeadField } from '#modules/LeadGeneration/hooks/field';
import { Box, TextField as MatTextField, Typography } from '@material-ui/core';
import * as React from 'react';

interface TextFieldProps {
  field: Field;
  multiline?: boolean;
  disabled?: boolean;
  defaultValue?: string;
  handleChangeFields?: (type: string, value: any) => void;
}

export const TextField = ({ field, multiline = false, disabled = false, handleChangeFields }: TextFieldProps) => {
  const [formField, { error, touched }, { setValue, setTouched }] = useLeadField(field);
  const { stylesLabel, textField } = useFieldStyles();

  return (
    <React.Fragment>
      <Box display='flex' alignItems='center' justifyContent='space-between'>
        <Typography variant='subtitle2' className={stylesLabel}>
          {field.title}
        </Typography>
      </Box>
      <MatTextField
        {...formField}
        className={textField}
        placeholder={field.placeholderText}
        fullWidth
        variant='outlined'
        error={Boolean(error && touched)}
        multiline={multiline}
        size='small'
        disabled={disabled}
        onChange={(e) => {
          formField.onChange(e);
          if (handleChangeFields) {
            if (field.type === EFieldType.TextBox || field.type === EFieldType.Textarea)
              handleChangeFields(field.id as string, e.target.value);
            else handleChangeFields(field.type, e.target.value);
          }
        }}
        InputProps={{ className: 'lead-input swyft-input' }}
      />
      {error && touched && (
        <Typography variant='subtitle2' color='error'>
          {error}
        </Typography>
      )}
    </React.Fragment>
  );
};
